import React from 'react';
import Styled from './styles';

export interface FileUploadLabelContainerProps extends React.ComponentPropsWithRef<'div'> {
  /** The content of this component */
  children: React.ReactNode;
}

/** Single list label wrapper for FileUpload list labels.
 * Any other props will be provided to the root element.
 * To get the ref of the outermost element use `ref` prop. [Read React useRef hook documentation](https://reactjs.org/docs/hooks-reference.)
 */
const FileUploadLabelContainer = React.forwardRef<HTMLElement, FileUploadLabelContainerProps>(({ children, ...otherProps }:
FileUploadLabelContainerProps, ref) => (
  <Styled.LabelContainer ref={ref} {...otherProps}>
    {children}
  </Styled.LabelContainer>
));

FileUploadLabelContainer.displayName = 'FileUploadLabelContainer';

export default FileUploadLabelContainer;
